import React , { useState } from 'react'
import styled from "styled-components";
import {  Row, Col, Button,Checkbox ,Table ,Form} from "antd";

const CreateWrap =styled.div`
.header{
  color: #1B1B1B;
   font-weight: bold;
}

.checkbox-cover .ant-checkbox-input:checked + .ant-checkbox-inner {
  background-color: green !important;
  border-color: green !important;
}

.checkbox-cover .ant-checkbox-input:focus + .ant-checkbox-inner {
  border-color: green !important;
}
  #Table1 {
  box-shadow: 0px 3px 6px #00000015;
  border-radius: 5px;
  height:300px;
    overflow-y: auto; /* Scroll vertically if content exceeds the height */
  overflow-x: hidden;
}
  .Comp-style{
padding-top:6px;
box-shadow:0px 3px 6px #00000014;
border-radius: 5px;
width: 250px;
height: 35px;
padding:5px;
paddingTop:5px
border: 1px solid #D6D6D6;
}
}
`
function CreateNew() {
    const [form] = Form.useForm();
    const [filteredData, setFilteredData] = useState([]);
   
  const dataSource = [
    {
      key: '1',
      Name: 'Cover 01.pdf',
      Competency: 'Audit',
      Added_By: 'Kennedy Wandhi',
    },
    {
        key: '2',
        Name: 'Cover 02.pdf',
        Competency: 'Tax',
        Added_By: 'Willow Lee',
      },
];
const Technicalproposal = [
    {
      key: '1',
      Name: 'Technical Proposal – submission letter 0001.pdf',
      Competency: 'Audit',
      Added_By: 'Kennedy Wandhi',
    },
    {
        key: '2',
        Name: 'Technical Proposal – submission letter 0002.pdf',
        Competency: 'Tax',
        Added_By: 'Willow Lee',
      },
      {
          key: '3',
          Name: 'Technical Proposal – submission letter 0003.pdf',
          Competency: 'Tax',
          Added_By: 'Willow Lee',
        },
];

const FirmsProfile = [
    {
      key: '1',
      Name: 'Firm’s Profile 01.pdf',
      Competency: 'Audit',
      Added_By: 'Kennedy Wandhi',
    },
    {
        key: '2',
        Name: 'Firm’s Profile 02.pdf',
        Competency: 'Tax',
        Added_By: 'Willow Lee',
      },
];
const Understanding = [
    {
      key: '1',
      Name: 'Understanding your needs file 01.pdf',
      Competency: 'Audit',
      Added_By: 'Kennedy Wandhi',
    },
    {
        key: '2',
        Name: 'Understanding your needs file 02.pdf',
        Competency: 'Tax',
        Added_By: 'Willow Lee',
      },
];
const BDOStatement = [
    {
      key: '1',
      Name: 'Qualification Statement 01.pdf',
      Competency: 'Audit',
      Added_By: 'Kennedy Wandhi',
    },
    {
        key: '2',
        Name: 'Qualification Statement 02.pdf',
        Competency: 'Tax',
        Added_By: 'Willow Lee',
      },
];
const IndustryEnv = [
    {
      key: '1',
      Name: 'Industry Environment and Trends 01.pdf',
      Competency: 'Audit',
      Added_By: 'Kennedy Wandhi',
    },
    {
        key: '2',
        Name: 'Industry Environment and Trends 02.pdf',
        Competency: 'Tax',
        Added_By: 'Willow Lee',
      },
];
const ValueAdded = [
    {
      key: '1',
      Name: 'Value-Added Services 01.pdf',
      Competency: 'Audit',
      Added_By: 'Kennedy Wandhi',
    },
    {
        key: '2',
        Name: 'Value-Added Services 02.pdf',
        Competency: 'Tax',
        Added_By: 'Willow Lee',
      },
];
const InternalAuditStrategic = [
    {
      key: '1',
      Name: 'Internal Audit Strategic Assessment Methodology 01.pdf',
      Competency: 'Audit',
      Added_By: 'Kennedy Wandhi',
    },
];
const InternalAuditApproach = [
    {
      key: '1',
      Name: 'Internal Audit Approach 01.pdf',
      Competency: 'Audit',
      Added_By: 'Kennedy Wandhi',
    },
    {
        key: '2',
        Name: 'Internal Audit Approach 02.pdf',
        Competency: 'Tax',
        Added_By: 'Willow Lee',
      },
];
const BDOApproach = [
    {
      key: '1',
      Name: 'BDO’s Approach to TDB’s Requirements 01.pdf',
      Competency: 'Audit',
      Added_By: 'Kennedy Wandhi',
    },
    {
        key: '2',
        Name: 'BDO’s Approach to TDB’s Requirements 02.pdf',
        Competency: 'Tax',
        Added_By: 'Willow Lee',
      },
];
const GeneralCommunication = [
    {
      key: '1',
      Name: 'General Communication 01.pdf',
      Competency: 'Audit',
      Added_By: 'Kennedy Wandhi',
    },
];
const ProposedService = [
    {
      key: '1',
      Name: 'Proposed Service Team 01.pdf',
      Competency: 'Audit',
      Added_By: 'Kennedy Wandhi',
    },
    {
        key: '2',
        Name: 'Proposed Service Team 02.pdf',
        Competency: 'Audit',
        Added_By: 'Kennedy Wandhi',
      },
      {
        key: '3',
        Name: 'Proposed Service Team 03.pdf',
        Competency: 'Audit',
        Added_By: 'Kennedy Wandhi',
      },
      {
        key: '4',
        Name: 'Proposed Service Team 04.pdf',
        Competency: 'Audit',
        Added_By: 'Kennedy Wandhi',
      },
    {
        key: '5',
        Name: 'Proposed Service Team 05.pdf',
        Competency: 'Tax',
        Added_By: 'Willow Lee',
      },
      {
        key: '6',
        Name: 'Proposed Service Team 06.pdf',
        Competency: 'Tax',
        Added_By: 'Willow Lee',
      },
];
const Resumes = [
  {
  }
];

const ClientRef = [
    {
      key: '1',
      Name: 'Client References 01.pdf',
      Competency: 'Audit',
      Added_By: 'Kennedy Wandhi',
    },
];

  const [loading, setLoading] = useState(false);
  const [selectedRows1, setSelectedRows1] = useState([]);
  const [selectedRows2, setSelectedRows2] = useState([]);
  const [selectedRows3, setSelectedRows3] = useState([]);
  const [selectedRows4, setSelectedRows4] = useState([]);
  const [selectedRows5, setSelectedRows5] = useState([]);
  const [selectedRows6, setSelectedRows6] = useState([]);
  const [selectedRows7, setSelectedRows7] = useState([]);
  const [selectedRows8, setSelectedRows8] = useState([]);
  const [selectedRows9, setSelectedRows9] = useState([]);
  const [selectedRows10, setSelectedRows10] = useState([]);
  const [selectedRows11, setSelectedRows11] = useState([]);
  const [selectedRows12, setSelectedRows12] = useState([]);
  const [selectedRows13, setSelectedRows13] = useState([]);
  const [selectedRows14, setSelectedRows14] = useState([]);

  const handleCheckboxChange = (checked, record, table) => {
    if (table === 'table1') {
      if (checked) {
        setSelectedRows1([...selectedRows1, record.key]);
      } else {
        setSelectedRows1(selectedRows1.filter((key) => key !== record.key));
      }
    } else if (table === 'table2') {
      if (checked) {
        setSelectedRows2([...selectedRows2, record.key]);
      } else {
        setSelectedRows2(selectedRows2.filter((key) => key !== record.key));
      }
    } else if (table === 'table3') {
      if (checked) {
        setSelectedRows3([...selectedRows3, record.key]);
      } else {
        setSelectedRows3(selectedRows3.filter((key) => key !== record.key));
      }
    } else if (table === 'table4') {
      if (checked) {
        setSelectedRows4([...selectedRows4, record.key]);
      } else {
        setSelectedRows4(selectedRows4.filter((key) => key !== record.key));
      }
    } else if (table === 'table5') {
      if (checked) {
        setSelectedRows5([...selectedRows5, record.key]);
      } else {
        setSelectedRows5(selectedRows5.filter((key) => key !== record.key));
      }
    } else if (table === 'table6') {
      if (checked) {
        setSelectedRows6([...selectedRows6, record.key]);
      } else {
        setSelectedRows6(selectedRows6.filter((key) => key !== record.key));
      }
    } else if (table === 'table7') {
      if (checked) {
        setSelectedRows7([...selectedRows7, record.key]);
      } else {
        setSelectedRows7(selectedRows7.filter((key) => key !== record.key));
      }
    } else if (table === 'table8') {
      if (checked) {
        setSelectedRows8([...selectedRows8, record.key]);
      } else {
        setSelectedRows8(selectedRows8.filter((key) => key !== record.key));
      }
    } else if (table === 'table9') {
      if (checked) {
        setSelectedRows9([...selectedRows9, record.key]);
      } else {
        setSelectedRows9(selectedRows9.filter((key) => key !== record.key));
      }
    } else if (table === 'table10') {
      if (checked) {
        setSelectedRows10([...selectedRows10, record.key]);
      } else {
        setSelectedRows10(selectedRows10.filter((key) => key !== record.key));
      }
    } else if (table === 'table11') {
      if (checked) {
        setSelectedRows11([...selectedRows11, record.key]);
      } else {
        setSelectedRows11(selectedRows11.filter((key) => key !== record.key));
      }
    } else if (table === 'table12') {
      if (checked) {
        setSelectedRows12([...selectedRows12, record.key]);
      } else {
        setSelectedRows12(selectedRows12.filter((key) => key !== record.key));
      }
    } else if (table === 'table13') {
      if (checked) {
        setSelectedRows13([...selectedRows13, record.key]);
      } else {
        setSelectedRows13(selectedRows13.filter((key) => key !== record.key));
      }
    } else if (table === 'table14') {
      if (checked) {
        setSelectedRows14([...selectedRows14, record.key]);
      } else {
        setSelectedRows14(selectedRows14.filter((key) => key !== record.key));
      }
    }
  };
  
  const columns1 = [
    {
        title: 'Name',
        dataIndex: 'Name',
        key: 'Name',
        width: "1800px",
        ellipsis: false,
        render: (text, record) => (
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', color: '#397EF3', display: 'flex', alignItems: 'center' }}>
              <Checkbox
                checked={selectedRows1.includes(record.key)}
                onChange={(e) => handleCheckboxChange(e.target.checked, record, 'table1')}
                className='checkbox-cover'
              />
              <span style={{ paddingLeft: '5px' }}>{text}</span> 
            </div>
          )     
      },
      {
        title: 'Competency',
        dataIndex: 'Competency',
        key: 'Competency',
        width: 600,
        ellipsis: false, // Disable truncation
        render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text       
      },
      {
        title: 'Added By',
        dataIndex:'Added_By',
        key: 'Added_By',
        width: 400,
        ellipsis: false, // Disable truncation
        render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text
       
      },]
      const columns2 = [
        {
            title: 'Name',
            dataIndex: 'Name',
            key: 'Name',
            width: "1800px",
            ellipsis: false,
            render: (text, record) => (
                <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', color: '#397EF3', display: 'flex', alignItems: 'center' }}>
                  <Checkbox
            className="checkbox-cover"
            checked={selectedRows2.includes(record.key)}
            onChange={(e) => handleCheckboxChange(e.target.checked, record, 'table2')}
          />
                  <span style={{ paddingLeft: '5px' }}>{text}</span> 
                </div>
              )     
          },
          {
            title: 'Competency',
            dataIndex: 'Competency',
            key: 'Competency',
            width: 600,
            ellipsis: false, // Disable truncation
            render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text       
          },
          {
            title: 'Added By',
            dataIndex:'Added_By',
            key: 'Added_By',
            width: 400,
            ellipsis: false, // Disable truncation
            render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text
           
          },
    ]
    const columns3 = [
        {
            title: 'Name',
            dataIndex: 'Name',
            key: 'Name',
            width: "1700px",
            ellipsis: false,
            render: (text, record) => (
                <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', color: '#397EF3', display: 'flex', alignItems: 'center' }}>
                  <Checkbox
                    checked={selectedRows3.includes(record.key)}
                    onChange={(e) => handleCheckboxChange(e.target.checked, record, 'table3')}
                    className='checkbox-cover'
                  />
                  <span style={{ paddingLeft: '5px' }}>{text}</span> 
                </div>
              )     
          },
          {
            title: 'Competency',
            dataIndex: 'Competency',
            key: 'Competency',
            width: 600,
            ellipsis: false, // Disable truncation
            render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text       
          },
          {
            title: 'Added By',
            dataIndex:'Added_By',
            key: 'Added_By',
            width: 400,
            ellipsis: false, // Disable truncation
            render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text
           
          },]
          const columns4 = [
            {
                title: 'Name',
                dataIndex: 'Name',
                key: 'Name',
                width: "1800px",
                ellipsis: false,
                render: (text, record) => (
                    <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', color: '#397EF3', display: 'flex', alignItems: 'center' }}>
                      <Checkbox
                        checked={selectedRows4.includes(record.key)}
                        onChange={(e) => handleCheckboxChange(e.target.checked, record, 'table4')}
                        className='checkbox-cover'
                      />
                      <span style={{ paddingLeft: '5px' }}>{text}</span> 
                    </div>
                  )     
              },
              {
                title: 'Competency',
                dataIndex: 'Competency',
                key: 'Competency',
                width: 600,
                ellipsis: false, // Disable truncation
                render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text       
              },
              {
                title: 'Added By',
                dataIndex:'Added_By',
                key: 'Added_By',
                width: 400,
                ellipsis: false, // Disable truncation
                render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text
               
              },]
              const columns5 = [
                {
                    title: 'Name',
                    dataIndex: 'Name',
                    key: 'Name',
                    width: "1800px",
                    ellipsis: false,
                    render: (text, record) => (
                        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', color: '#397EF3', display: 'flex', alignItems: 'center' }}>
                          <Checkbox
                            checked={selectedRows5.includes(record.key)}
                            onChange={(e) => handleCheckboxChange(e.target.checked, record, 'table5')}
                            className='checkbox-cover'
                          />
                          <span style={{ paddingLeft: '5px' }}>{text}</span> 
                        </div>
                      )     
                  },
                  {
                    title: 'Competency',
                    dataIndex: 'Competency',
                    key: 'Competency',
                    width: 600,
                    ellipsis: false, // Disable truncation
                    render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text       
                  },
                  {
                    title: 'Added By',
                    dataIndex:'Added_By',
                    key: 'Added_By',
                    width: 400,
                    ellipsis: false, // Disable truncation
                    render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text
                   
                  },]
                  const columns6 = [
                    {
                        title: 'Name',
                        dataIndex: 'Name',
                        key: 'Name',
                        width: "1800px",
                        ellipsis: false,
                        render: (text, record) => (
                            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', color: '#397EF3', display: 'flex', alignItems: 'center' }}>
                              <Checkbox
                                checked={selectedRows6.includes(record.key)}
                                onChange={(e) => handleCheckboxChange(e.target.checked, record, 'table6')}
                                className='checkbox-cover'
                              />
                              <span style={{ paddingLeft: '5px' }}>{text}</span> 
                            </div>
                          )     
                      },
                      {
                        title: 'Competency',
                        dataIndex: 'Competency',
                        key: 'Competency',
                        width: 600,
                        ellipsis: false, // Disable truncation
                        render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text       
                      },
                      {
                        title: 'Added By',
                        dataIndex:'Added_By',
                        key: 'Added_By',
                        width: 400,
                        ellipsis: false, // Disable truncation
                        render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text
                       
                      },]
                      const columns7 = [
                        {
                            title: 'Name',
                            dataIndex: 'Name',
                            key: 'Name',
                            width: "1800px",
                            ellipsis: false,
                            render: (text, record) => (
         <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', color: '#397EF3', display: 'flex', alignItems: 'center' }}>
           <Checkbox
             checked={selectedRows7.includes(record.key)}
             onChange={(e) => handleCheckboxChange(e.target.checked, record, 'table7')}
             className='checkbox-cover'
           />
           <span style={{ paddingLeft: '5px' }}>{text}</span> 
         </div>
       )     
   },
   {
     title: 'Competency',
     dataIndex: 'Competency',
     key: 'Competency',
     width: 600,
     ellipsis: false, // Disable truncation
     render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text       
   },
   {
     title: 'Added By',
     dataIndex:'Added_By',
     key: 'Added_By',
     width: 400,
     ellipsis: false, // Disable truncation
     render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text
    
   },]
   const columns8 = [
     {
         title: 'Name',
         dataIndex: 'Name',
         key: 'Name',
         width: "1800px",
         ellipsis: false,
         render: (text, record) => (
             <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', color: '#397EF3', display: 'flex', alignItems: 'center' }}>
               <Checkbox
                 checked={selectedRows8.includes(record.key)}
                 onChange={(e) => handleCheckboxChange(e.target.checked, record, 'table8')}
                 className='checkbox-cover'
               />
               <span style={{ paddingLeft: '5px' }}>{text}</span> 
             </div>
           )     
       },
       {
         title: 'Competency',
         dataIndex: 'Competency',
         key: 'Competency',
         width: 600,
         ellipsis: false, // Disable truncation
         render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text       
       },
       {
         title: 'Added By',
         dataIndex:'Added_By',
         key: 'Added_By',
         width: 400,
         ellipsis: false, // Disable truncation
         render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text
        
       },]
       const columns9 = [
         {
             title: 'Name',
             dataIndex: 'Name',
             key: 'Name',
             width: "1800px",
             ellipsis: false,
             render: (text, record) => (
                 <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', color: '#397EF3', display: 'flex', alignItems: 'center' }}>
                   <Checkbox
                     checked={selectedRows9.includes(record.key)}
                     onChange={(e) => handleCheckboxChange(e.target.checked, record, 'table9')}
                     className='checkbox-cover'
                   />
                   <span style={{ paddingLeft: '5px' }}>{text}</span> 
                 </div>
               )     
           },
           {
             title: 'Competency',
             dataIndex: 'Competency',
             key: 'Competency',
             width: 600,
             ellipsis: false, // Disable truncation
             render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text       
           },
           {
             title: 'Added By',
             dataIndex:'Added_By',
             key: 'Added_By',
             width: 400,
              ellipsis: false, // Disable truncation
               render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text
                },]
                
   const columns10 = [
   {
       title: 'Name',
       dataIndex: 'Name',
       key: 'Name',
       width: "1800px",
       ellipsis: false,
       render: (text, record) => (
           <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', color: '#397EF3', display: 'flex', alignItems: 'center' }}>
             <Checkbox
               checked={selectedRows10.includes(record.key)}
               onChange={(e) => handleCheckboxChange(e.target.checked, record, 'table10')}
               className='checkbox-cover'
             />
             <span style={{ paddingLeft: '5px' }}>{text}</span> 
           </div>
         )     
     },
     {
       title: 'Competency',
       dataIndex: 'Competency',
       key: 'Competency',
       width: 600,
       ellipsis: false, // Disable truncation
       render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text       
     },
     {
       title: 'Added By',
       dataIndex:'Added_By',
       key: 'Added_By',
       width: 400,
       ellipsis: false, // Disable truncation
       render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text
      
     },]
     const columns11 = [
       {
           title: 'Name',
           dataIndex: 'Name',
           key: 'Name',
           width: "1800px",
           ellipsis: false,
           render: (text, record) => (
               <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', color: '#397EF3', display: 'flex', alignItems: 'center' }}>
                 <Checkbox
                   checked={selectedRows11.includes(record.key)}
                   onChange={(e) => handleCheckboxChange(e.target.checked, record, 'table11')}
                   className='checkbox-cover'
                 />
                 <span style={{ paddingLeft: '5px' }}>{text}</span> 
               </div>
                                              )     
},
{
  title: 'Competency',
  dataIndex: 'Competency',
  key: 'Competency',
  width: 600,
  ellipsis: false, // Disable truncation
  render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text       
},
{
  title: 'Added By',
  dataIndex:'Added_By',
  key: 'Added_By',
  width: 400,
  ellipsis: false, // Disable truncation
  render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text
 
},]
const columns12 = [
  {
      title: 'Name',
      dataIndex: 'Name',
      key: 'Name',
      width: "1800px",
      ellipsis: false,
      render: (text, record) => (
          <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', color: '#397EF3', display: 'flex', alignItems: 'center' }}>
            <Checkbox
              checked={selectedRows12.includes(record.key)}
              onChange={(e) => handleCheckboxChange(e.target.checked, record, 'table12')}
              className='checkbox-cover'
            />
            <span style={{ paddingLeft: '5px' }}>{text}</span> 
          </div>
        )     
    },
    {
      title: 'Competency',
      dataIndex: 'Competency',
      key: 'Competency',
      width: 600,
      ellipsis: false, // Disable truncation
      render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text       
    },
    {
      title: 'Added By',
      dataIndex:'Added_By',
      key: 'Added_By',
      width: 400,
      ellipsis: false, // Disable truncation
      render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text
     
    },]
    const columns13 = [
      {
        title: 'Select Employee From The Dropdown',
        dataIndex: 'Select_Employee_From_The_Dropdown',
        key: 'Select_Employee_From_The_Dropdown',
        ellipsis: false,
        render: (text, record) => (
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              lineHeight: '1.5',
              color: '#397EF3',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            {/* Main text */}
            <span style={{ paddingLeft: '5px' }}>{text}</span>
    
            {/* Checkbox group */}
            <div>
              <p style={{color:"#000000"}}>Employee</p>
            <Checkbox.Group>
              <label className="Comp-style" >
                Select
              </label>
            </Checkbox.Group></div>
    
            {/* Selected Team Heading */}
            <p
              style={{
                textDecoration: 'underline',
                color: '#181818',
                marginTop: '10px',
              }}
            >
              Selected Team
            </p>
          </div>
        ),
      },
    ];
    
const columns14 = [
  {
      title: 'Name',
      dataIndex: 'Name',
      key: 'Name',
      width: "1800px",
      ellipsis: false,
      render: (text, record) => (
          <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', color: '#397EF3', display: 'flex', alignItems: 'center' }}>
            <Checkbox
              checked={selectedRows14.includes(record.key)}
              onChange={(e) => handleCheckboxChange(e.target.checked, record, 'table14')}
              className='checkbox-cover'
            />
            <span style={{ paddingLeft: '5px' }}>{text}</span> 
          </div>
        )     
    },
    {
      title: 'Competency',
      dataIndex: 'Competency',
      key: 'Competency',
      width: 600,
      ellipsis: false, // Disable truncation
      render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text       
    },
    {
      title: 'Added By',
      dataIndex:'Added_By',
      key: 'Added_By',
      width: 400,
      render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text
                                                       
                                                      },]
  return (
    <CreateWrap>
    <div>
     <p className='header'>Create New Proposal</p> 
     <Checkbox className="checkbox-cover"
     style={{textDecoration:"underline",  fontWeight: "bold" ,paddingBottom:"5px"}}>Cover</Checkbox>
    </div>
    <Row gutter={12} className="g-3 mb-2">
  <Col xs={24} sm={24} md={12} lg={8} xl={4}>
    <Checkbox.Group>
      <label className='Comp-style'>Competency</label>
      {/* Options can be added here later if needed */}
    </Checkbox.Group>
  </Col>
  <Col xs={24} sm={24} md={12} lg={8} xl={4}>
        <Button
          type="primary"
          style={{
            width: "173px",
            height: "35px",
            background: "#C2FAE5 0% 0% no-repeat padding-box",
            borderRadius: "5px", 
            opacity: "1",
            // padding: "0 15px",
             marginLeft: "830px",
        color:"#000000",
          }}
        >
          Upload New File
        </Button>
      </Col>
  </Row>

  <Table
               dataSource={dataSource}
                columns={columns1}
                size="middle"
                pagination={false}
                loading={loading}
                id="Table1"
              />
              <div>
                <div>
              <Checkbox className="checkbox-cover"
             style={{textDecoration:"underline",  fontWeight: "bold",paddingTop:"15px",paddingBottom:"5px" }}>Technical Proposal – Submission Letter</Checkbox></div>
             <Checkbox.Group>
                <div>
      <label className='Comp-style'>Competency</label>
      {/* Options can be added here later if needed */}</div>
    </Checkbox.Group>
               <Table
               dataSource={Technicalproposal}
                columns={columns2}
                size="middle"
                pagination={false}
                loading={loading}
                id="Table1"
              />
              </div>

              <div>
                <div>
              <Checkbox className="checkbox-cover"
             style={{textDecoration:"underline",  fontWeight: "bold",paddingTop:"15px",paddingBottom:"5px" }}>Firm’s Profile</Checkbox></div>
             <Checkbox.Group>
                <div>
      <label className='Comp-style'>Competency</label>
      {/* Options can be added here later if needed */}</div>
    </Checkbox.Group>
               <Table
               dataSource={FirmsProfile}
                columns={columns3}
                size="middle"
                pagination={false}
                loading={loading}
                id="Table1"
              />
              </div>
              <div>
                <div>
              <Checkbox className="checkbox-cover"
             style={{textDecoration:"underline",  fontWeight: "bold",paddingTop:"15px",paddingBottom:"5px" }}>Understanding Your Needs</Checkbox></div>
             <Checkbox.Group>
                <div>
      <label className='Comp-style'>Competency</label>
      {/* Options can be added here later if needed */}</div>
    </Checkbox.Group>
               <Table
               dataSource={Understanding}
                columns={columns4}
                size="middle"
                pagination={false}
                loading={loading}
                id="Table1"
              />
              </div>
              <div>
                <div>
              <Checkbox className="checkbox-cover"
             style={{textDecoration:"underline",  fontWeight: "bold",paddingTop:"15px",paddingBottom:"5px" }}>Bdo Statement Of Qualification</Checkbox></div>
             <Checkbox.Group>
                <div>
      <label className='Comp-style'>Competency</label>
      {/* Options can be added here later if needed */}</div>
    </Checkbox.Group>
               <Table
               dataSource={BDOStatement}
                columns={columns5}
                size="middle"
                pagination={false}
                loading={loading}
                id="Table1"
              />
              </div>
              <div>
                <div>
              <Checkbox className="checkbox-cover"
             style={{textDecoration:"underline",  fontWeight: "bold",paddingTop:"15px",paddingBottom:"5px" }}>Industry Environment And Trends</Checkbox></div>
             <Checkbox.Group>
                <div>
      <label className='Comp-style'>Competency</label>
      {/* Options can be added here later if needed */}</div>
    </Checkbox.Group>
               <Table
               dataSource={IndustryEnv}
                columns={columns6}
                size="middle"
                pagination={false}
                loading={loading}
                id="Table1"
              />
              </div>
              <div>
                <div>
              <Checkbox className="checkbox-cover"
             style={{textDecoration:"underline",  fontWeight: "bold",paddingTop:"15px",paddingBottom:"5px" }}>Value-Added Services</Checkbox></div>
             <Checkbox.Group>
                <div>
      <label className='Comp-style'>Competency</label>
      {/* Options can be added here later if needed */}</div>
    </Checkbox.Group>
               <Table
               dataSource={ValueAdded}
                columns={columns7}
                size="middle"
                pagination={false}
                loading={loading}
                id="Table1"
              />
              </div>
              <div>
                <div>
              <Checkbox className="checkbox-cover"
             style={{textDecoration:"underline",  fontWeight: "bold",paddingTop:"15px",paddingBottom:"5px" }}>Internal Audit Strategic Assessment Methodology</Checkbox></div>
             <Checkbox.Group>
                <div>
      <label className='Comp-style'>Competency</label>
      {/* Options can be added here later if needed */}</div>
    </Checkbox.Group>
               <Table
               dataSource={InternalAuditStrategic}
                columns={columns8}
                size="middle"
                pagination={false}
                loading={loading}
                id="Table1"
              />
              </div>
              <div>
                <div>
              <Checkbox className="checkbox-cover"
             style={{textDecoration:"underline",  fontWeight: "bold",paddingTop:"15px",paddingBottom:"5px" }}>Internal Audit Approach</Checkbox></div>
             <Checkbox.Group>
                <div>
      <label className='Comp-style'>Competency</label>
      {/* Options can be added here later if needed */}</div>
    </Checkbox.Group>
               <Table
               dataSource={InternalAuditApproach}
                columns={columns9}
                size="middle"
                pagination={false}
                loading={loading}
                id="Table1"
              />
              </div>
              <div>
                <div>
              <Checkbox className="checkbox-cover"
             style={{textDecoration:"underline",  fontWeight: "bold",paddingTop:"15px",paddingBottom:"5px" }}>Bdo’s Approach To Tdb’s Requirements</Checkbox></div>
             <Checkbox.Group>
                <div>
      <label className='Comp-style'>Competency</label>
      {/* Options can be added here later if needed */}</div>
    </Checkbox.Group>
               <Table
               dataSource={BDOApproach}
                columns={columns10}
                size="middle"
                pagination={false}
                loading={loading}
                id="Table1"
              />
              </div>
              <div>
                <div>
              <Checkbox className="checkbox-cover"
             style={{textDecoration:"underline",  fontWeight: "bold",paddingTop:"15px",paddingBottom:"5px" }}>General Communication</Checkbox></div>
             <Checkbox.Group>
                <div>
      <label className='Comp-style'>Competency</label>
      {/* Options can be added here later if needed */}</div>
    </Checkbox.Group>
               <Table
               dataSource={GeneralCommunication}
                columns={columns11}
                size="middle"
                pagination={false}
                loading={loading}
                id="Table1"
              />
              </div>
              <div>
                <div>
              <Checkbox className="checkbox-cover"
             style={{textDecoration:"underline",  fontWeight: "bold",paddingTop:"15px",paddingBottom:"5px" }}>Proposed Service Team</Checkbox></div>
             <Checkbox.Group>
                <div>
      <label className='Comp-style'>Competency</label>
      {/* Options can be added here later if needed */}</div>
    </Checkbox.Group>
               <Table
               dataSource={ProposedService}
                columns={columns12}
                size="middle"
                pagination={false}
                loading={loading}
                id="Table1"
              />
              </div>
              <div>
                <div>
              <Checkbox className="checkbox-cover"
             style={{textDecoration:"underline",  fontWeight: "bold",paddingTop:"15px",paddingBottom:"5px" }}>Resumes of Proposed Team </Checkbox></div>
               <Table
               dataSource={Resumes}
                columns={columns13}
                size="middle"
                pagination={false}
                loading={loading}
                id="Table1"
              />
              </div>
              <div>
                <div>
              <Checkbox className="checkbox-cover"
             style={{textDecoration:"underline",  fontWeight: "bold",paddingTop:"15px",paddingBottom:"5px" }}>Client References </Checkbox></div>
               <Table
               dataSource={ClientRef}
                columns={columns14}
                size="middle"
                pagination={false}
                loading={loading}
                id="Table1"
              />
              </div>
    </CreateWrap>
  )
}

export default CreateNew
